<div class="w-full bg-[#fcfdff] border-t-[1px] border-t-[#C9DDF480]">
    <div class="max-w-[30rem] flex justify-center">
        <div class="p-8">
            <div [class]="dialogModel.icon + ' icon-[5rem] m-auto'"></div>

            <p
                class="text-black font-semibold text-2xl text-center mt-4"
                [innerHTML]="dialogModel.title | translate"></p>

            <div
                *ngIf="dialogModel.subText1"
                class="text-[#5F5B5B] font-lato text-base font-normal text-center mt-2"
                [innerHTML]="dialogModel.subText1 | translate"></div>

            <div
                *ngIf="dialogModel.subText2"
                class="text-[#5F5B5B] font-lato text-base font-normal text-center mt-2"
                [innerHTML]="dialogModel.subText2 | translate"></div>

            <button type="button" class="btn-primary mt-7 m-auto button-padding" (click)="close()">
                {{ dialogModel.closeButton | translate }}
            </button>
        </div>
    </div>
</div>
